import { MAX_FILTER_VALUES } from '@/infrastructure/api/v1/lists';

/** Shown instead of saving a reorder the server cannot make. */
export const REORDER_PAST_LIMIT_MESSAGE = `Stories can't be moved past position ${MAX_FILTER_VALUES}.`;

/**
 * The ids a story reorder sends (reorderStories) and the order the project then has. The server takes
 * at most 100 ids and places the project's other stories after them in their current order, so only
 * the ids up to the last moved position are sent, capped at 100, and the stories past them keep their
 * previous order. `exact` is false when that order is not `next` (a move past position 100); callers
 * then refuse the drop. No ids means nothing moved.
 */
export function storyReorder<S extends { id: string }>(
  previous: readonly S[],
  next: readonly S[],
): { storyIds: string[]; ordered: S[]; exact: boolean } {
  let moved = next.length;
  while (moved > 0 && next[moved - 1].id === previous[moved - 1]?.id) moved--;
  const listed = next.slice(0, Math.min(moved, MAX_FILTER_VALUES));
  const listedIds = new Set(listed.map((story) => story.id));
  const ordered = [...listed, ...previous.filter((story) => !listedIds.has(story.id))];
  return {
    storyIds: listed.map((story) => story.id),
    ordered,
    exact: ordered.every((story, i) => story.id === next[i]?.id),
  };
}
